<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<p class="centerf">Praise for</p>
<figure class="image"><span epub:type="pagebreak" id="page_i" title="i"><img alt="Images" src="images/f000i-01.jpg"/>
<figcaption></figcaption>
</span></figure>
<p class="centerf1">“A Hollywood adventure that’s truly out of this world! <em>Alien Superstar</em> has it all . . . action, suspense, and big laughs!”</p>
<p class="centerfr">—Jeff Kinney, author of the Diary of a Wimpy Kid series</p>
<p class="centerf1">“Henry Winkler and Lin Oliver keep us laughing while slipping in a lesson for kids—accept everyone as they are, even if they have suction cups for feet . . . A super fun read.”</p>
<p class="centerfr">—Jennifer Garner</p>
<p class="centerf1">“Out of this world . . . will resonate with any kid who has felt like an outsider.”</p>
<p class="centerfr">—<em>Booklist</em></p>
<p class="centerf1">“A funny interstellar adventure that will have readers watching the cosmos for the second book to arrive.”</p>
<p class="centerfr">—<em>School Library Journal</em></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?7d1451f7